/**
 * Horizontal filter control bar (pill container + slots)
 */

import { ReactNode } from 'react'
import { Search } from 'lucide-react'

interface FilterBarProps {
  /** e.g. "Active filters" label */
  leading?: ReactNode
  /** Dropdowns or selects */
  filters?: ReactNode
  searchPlaceholder?: string
  searchValue?: string
  onSearchChange?: (value: string) => void
  className?: string
}

export function FilterBar({
  leading,
  filters,
  searchPlaceholder = 'Search…',
  searchValue,
  onSearchChange,
  className = '',
}: FilterBarProps) {
  return (
    <div
      className={`flex min-h-[3.25rem] flex-wrap items-center gap-3 rounded-pill border border-gray-200/90 bg-white px-4 py-2 shadow-sm sm:gap-0 sm:px-5 ${className}`}
    >
      {leading != null && (
        <div className="flex min-w-0 shrink-0 items-center gap-2 border-gray-200 pr-3 sm:border-r sm:py-0.5">
          {leading}
        </div>
      )}
      {filters != null && (
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2 sm:gap-0 sm:divide-x sm:divide-gray-200 sm:px-3">
          {filters}
        </div>
      )}
      <div className="relative ml-auto w-full min-w-[12rem] sm:w-56 sm:flex-none">
        <Search
          className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
          aria-hidden
        />
        <input
          type="search"
          value={searchValue}
          onChange={e => onSearchChange?.(e.target.value)}
          placeholder={searchPlaceholder}
          className="w-full rounded-pill border border-gray-200 bg-gray-50/80 py-2 pl-9 pr-3 text-sm text-gray-900 placeholder:text-gray-400 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20"
        />
      </div>
    </div>
  )
}
